import { BoxConfig } from '@euler/app/components/LicensePlateNoInput';
import {
  KeyColors,
  LicensePlateNoKeyboard,
} from '@euler/app/components/LicensePlateNoKeyboard';
import { Panel } from '@euler/app/tv/components/Panel';
import { useSearchCriteriaContext } from '@euler/app/tv/functions/SearchCriteriaContext';
import { usePresentationTheme } from '@euler/app/tv/theme';
import { LayoutProviderView } from '@euler/components/layout/LayoutProvider';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useBehaviorSubjectUpdater } from '@euler/utils/hooks';
import { memo, useMemo } from 'react';
import { StyleProp, ViewStyle } from 'react-native';

export const LicensePlateNoPanel = memo(
  ({
    style,
    onSearch,
  }: {
    style?: StyleProp<ViewStyle>;
    onSearch?: () => void;
  }) => {
    const { query$ } = useSearchCriteriaContext();
    const updateQuery = useBehaviorSubjectUpdater(query$);
    const { rpx } = useResponsiveContext();
    const {
      lpn: {
        input: { borderColor, activeBorderColor, textColor },
        keyboard: { btnBgColor, btnTextColor, doneBtnBgColor },
      },
    } = usePresentationTheme();

    const boxConfig = useMemo<BoxConfig>(
      () => ({
        backgroundColor: 'transparent',
        borderWidth: rpx(2, { round: 'ceil' }),
        borderRadius: rpx(8),
        borderColor: borderColor,
        borderColorSelected: activeBorderColor,
        textColor,
        size: rpx(48),
        textStyle: {
          fontSize: rpx(24),
          lineHeight: rpx(28),
        },
        ecoTextStyle: {
          fontSize: rpx(18),
          lineHeight: rpx(22),
        },
      }),
      [activeBorderColor, borderColor, rpx, textColor],
    );

    const keyColors = useMemo<KeyColors>(
      () => ({
        keyBgColor: btnBgColor,
        funcKeyBgColor: btnBgColor,
        keyColor: btnTextColor,
        disabledKeyColor: btnTextColor,
        doneKeyBgColor: doneBtnBgColor,
      }),
      [btnBgColor, btnTextColor, doneBtnBgColor],
    );

    return (
      <Panel style={style}>
        <LayoutProviderView>
          {({ width }) => (
            <LicensePlateNoKeyboard
              width={width}
              doneButtonText={'搜索'}
              boxConfig={boxConfig}
              keyWidth={rpx(44)}
              keyHeight={rpx(44)}
              keyColors={keyColors}
              keyTextStyle={{
                fontSize: rpx(24),
                lineHeight: rpx(28),
              }}
              backspaceKeySize={rpx(28)}
              allowPartialInput
              alwaysEnableDoneButton
              onChange={updateQuery}
              onDone={onSearch}
            />
          )}
        </LayoutProviderView>
      </Panel>
    );
  },
);
